import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import Loading from "react-loading";
import "./styles/veiculosInfo.css";

export function VeiculosInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllVeiculosById(id, config).then((res) => {
                    setData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    const formatInfoVeiculos = (info) => {
        if (info === '["","","",""]') {
            return "Não informados";
        } else {
            return info;
        }
    }

    

    console.log(data[0].adesivoRefletivo)

    return (
        <div>
            <div className="container-veiculos-info">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">Veículos</h1>
                </div>
                {data.map((check, i) => {
                    return (
                        <main className="datagrid-container-veiculos">
                            <div className="table-content-veiculos">
                                <br></br>
                                <br></br>
                                <div>
                                    <thead>
                                        <tr>
                                            <th>Tipo do veículo</th>
                                            <th>Capacidade do veículo</th>
                                            <th>Data</th>
                                            <th>Marca / Modelo</th>
                                            <th>Ano de fabricação</th>
                                            <th>Placa</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>
                                            {check.veiculoTipo
                                                ? check.veiculoTipo
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.veiculoNome
                                                ? check.veiculoNome
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.data
                                                ? formatDate(
                                                    check.data
                                                  )
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.carroSelecionadoNome
                                                ? check.carroSelecionadoNome
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.carroSelecionadoAno
                                                ? check.carroSelecionadoAno
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.carroSelecionadoPlaca
                                                ? check.carroSelecionadoPlaca
                                                : "Não informado"}
                                        </td>
                                    </tbody>
                                </div>
                                <br></br>
                                <br></br>
                                <div>
                                    <thead>
                                        <tr>
                                            <th>Documentação do veículo</th>
                                            <th>Retograma para circulação externa</th>
                                            <th>Funcionamento da buzina</th>
                                            <th>Condições/Funcionamento do limpador para-brisa</th>
                                            <th>Limpeza externa e interna</th>
                                            <th>Condições dos vidros(laminados), portas, travas e lataria</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>
                                           Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.documentacaoVeiculo)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.rotogramaExterna)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.funcionamentoBuzina)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.condicoesLimpador)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.limpezaExternaInterna)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.condicoesVidros)}
                                        </td>
                                    </tbody>
                                </div>
                                <br></br>
                                <br></br>
                                <div>
                                    <thead>
                                        <tr>
                                            <th>Espelhos retrovisores (internos e externos)</th>
                                            <th>Comandos (alavanca e pedais)</th>
                                            <th>Bancos (fixação e estofamento)</th>
                                            <th>Chave de roda, macaco e triangulo de sinalização</th>
                                            <th>Coletes refletivos (mínimo 2)</th>
                                            <th>Pneus e estepe (verificar indicador de desgaste(TWI) mínimo 2,6mm)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.espelhosRetrovisores)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.alavancasPedais)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.bancosFixacao)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.chaveRoda)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.coletesRefletivos)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.pneusEstepe)}
                                        </td>
                                    </tbody>
                                </div>
                                <br></br>
                                <br></br>
                                <div>
                                    <thead>
                                        <tr>
                                            <th>Funcionamento do cinto de segurança</th>
                                            <th>Funcionamento das luzes (Faróis, suplementar de freio, placa, ré, pisca alerta e setas)</th>
                                            <th>Nível dos reservatorios (água, combustível, óleo). Verificar se há vazamentos</th>
                                            <th>Funcionamento do ar condicionado</th>
                                            <th>Motorista e turno utilizado</th>
                                            <th>Observações Kms</th>
                                            <th>Observações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.funcionamentoCinto)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.funcionamentoLuzes)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.nivelReservatorios)}
                                        </td>
                                        <td>
                                        Turnos 1 a 3 e ADM: {formatInfoVeiculos(check.arCondicionado)}
                                        </td>
                                        <td>
                                        {check.motorista
                                                ? check.motorista
                                                : "Não informados"} - { check.usuarioTurno ? check.usuarioTurno : "Não informado" }
                                        </td>
                                        <td>
                                            {check.observacaoKms
                                                ? check.observacaoKms
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.observacao
                                                ? check.observacao
                                                : "Não informado"}
                                        </td>
                                    </tbody>
                                </div>
                            </div>
                        </main>
                    );
                })}
            </div>
        </div>
    );
}
